import { render } from "./Vnud-Login.vue?vue&type=template&id=a71e0c1e"
import script from "./Vnud-Login.vue?vue&type=script&lang=js"
export * from "./Vnud-Login.vue?vue&type=script&lang=js"

import "./Vnud-Login.vue?vue&type=style&index=0&id=a71e0c1e&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__